module.exports = __webpack_public_path__ + "img/icon-location-2.fb81d513.svg";